import { render, staticRenderFns } from "./LoginPasswordForm.vue?vue&type=template&id=490a1cba&lang=pug&"
import script from "./LoginPasswordForm.vue?vue&type=script&lang=js&"
export * from "./LoginPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports